module.exports = __webpack_public_path__ + "static/img/7.dc5d358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.png
// module id = y4L6
// module chunks = 3